import React, { useCallback } from 'react';

import { SubscriptionFormBlockKind } from '@mssgme/shared';
import { feedbackApi } from '@mssgme/lib';
import { LandingsPropTypes, useMergedStyles } from '@mssgme/ui';

import { useBlockTheme, useWebsiteData } from '../../../hooks';
import { BlockBase } from '../BlockBase';
import { SubscriptionFormContent } from './SubscriptionFormContent';

export default function SubscriptionForm({ block, style: baseStyle, interactive, ...rest }) {
    const { theme, style } = useBlockTheme(block);
    const website = useWebsiteData();
    const combined = useMergedStyles(style, baseStyle);

    const handleSubmit = useCallback(
        async (values) => {
            if (!interactive) {
                return;
            }

            await feedbackApi.submit(website.workspace, website._id, { blockId: block._id, data: values });

            const submitEvent = new CustomEvent('formSubmitted', {
                detail: block._id,
            });

            document.dispatchEvent(submitEvent);
        },
        [website, interactive]
    );

    return (
        <BlockBase
            as={SubscriptionFormContent}
            interactive={interactive}
            block={block}
            style={combined}
            theme={theme}
            onSubmit={handleSubmit}
            {...rest}
        />
    );
}

SubscriptionForm.propTypes = {
    ...BlockBase.propTypes,
    block: LandingsPropTypes.block.isRequired,
};

SubscriptionForm.defaultProps = BlockBase.defaultProps;

SubscriptionForm.kind = SubscriptionFormBlockKind;
